/* global globalThis */
import React from "react";
import { CNavLink } from "./c/CHeader";
import CUserImageIcon from "../../CUserImageIcon";
import { useTranslations, useLogout } from "sdk/custom-hooks";
import { Box, List, ListItem, Typography } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { getUser } from "sdk/actions";
import PropTypes from "prop-types";

/**
 * UserMenuList
 * @param props
 * @returns {*}
 * @constructor
 */
function UserMenuList({ user, profile }) {
  const userName = user?.user?.name || user?.name;
  const userImage = user?.user?.image || user?.image;
  const userCity = user?.user?.city || user?.city;
  const dispatch = useDispatch();
  const t = useTranslations();
  const logout = useLogout();

  const handleProfileClick = () => {
    dispatch(getUser());
  };

  return (
    <React.Fragment>
      {profile ? (
        <Box id="userSectionId">
          <CUserImageIcon src={userImage} />
          <List className="sub-menus">
            <ListItem onClick={handleProfileClick}>
              <CNavLink to="/my-profile">{t("my_profile")}</CNavLink>
            </ListItem>
            <ListItem onClick={() => logout()}>{t("logout")}</ListItem>
          </List>
        </Box>
      ) : (
        <Box id="contentBlockId">
          <Typography variant="inherit" className="profile-info" id="contentId">
            {userName}
          </Typography>
          <Typography
            variant="inherit"
            className="profile-info"
            id="content2Id"
          >
            {userCity}
          </Typography>
        </Box>
      )}
    </React.Fragment>
  );
}

export default UserMenuList;

const userShape = PropTypes.shape({
  name: PropTypes.string,
  image: PropTypes.string,
  city: PropTypes.string,
});

UserMenuList.propTypes = {
  profile: PropTypes.bool,
  user: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.string,
    city: PropTypes.string,
    user: userShape,
  }),
};
